"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("mask", {
  x: "3",
  y: "5",
  width: "18",
  height: "15",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "m12 19.4h9v-14.4h-18v14.4z",
  clipRule: "evenodd",
  fill: "#fff",
  fillRule: "evenodd"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3,4.8)"
}, /*#__PURE__*/React.createElement("path", {
  transform: "translate(-3,-4.8)",
  d: "m4.8008 4.8008c-0.994 0-1.8008 0.75741-1.8008 1.6914v8.4727c0 0.936 0.80678 1.6934 1.8008 1.6934h0.63672c0 1.404 1.2092 2.541 2.7012 2.541 1.49 0 2.6992-1.137 2.6992-2.541h3.8262c0 1.404 1.2072 2.541 2.6992 2.541 1.49 0 2.7012-1.137 2.7012-2.541h0.035156c0.497 0 0.90039-0.3777 0.90039-0.8457v-2.1191l-2.2324-4.9004c-0.283-0.624-0.9343-1.0273-1.6543-1.0273h-2.4141v-1.2734c0-0.933-0.80483-1.6914-1.7988-1.6914h-8.0996zm1.2246 2.3457h0.75781c0.104-5e-3 0.20688 0.019312 0.29688 0.070312 0.089 0.051 0.16198 0.12775 0.20898 0.21875l1.5977 2.8613 1.7168-2.8613c0.048-0.09 0.11898-0.1648 0.20898-0.2168 0.09-0.051 0.19288-0.075312 0.29688-0.070312h0.70508c0.27 0 0.41245 0.13025 0.43945 0.40625l0.41797 5.2461c0.026 0.288-0.12039 0.43164-0.40039 0.43164h-0.91797c-0.266 0-0.41278-0.13025-0.42578-0.40625l-0.12891-3.0684-1.1562 1.9551c-0.045 0.091-0.11508 0.1687-0.20508 0.2207-0.089 0.052-0.19192 0.077265-0.29492 0.072265h-0.58594c-0.104 5e-3 -0.20688-0.020312-0.29688-0.070312-0.089-0.052-0.16298-0.1287-0.20898-0.2207l-1.0293-1.8223-0.18555 2.9375c4e-3 0.057-0.0043906 0.11206-0.025391 0.16406-0.021 0.054-0.053703 0.10162-0.095703 0.14062-0.042 0.038-0.092484 0.066984-0.14648 0.083984-0.055 0.017-0.11292 0.021672-0.16992 0.013672h-0.85156c-0.274 0-0.4273-0.14864-0.4043-0.43164l0.44336-5.2461c0.027-0.28 0.17345-0.4082 0.43945-0.4082zm8.6738 2.3145h2.4141l1.1562 2.5391h-3.5703v-2.5391zm-6.5625 6.3496c0.496 0 0.90039 0.38066 0.90039 0.84766s-0.40439 0.84766-0.90039 0.84766c-0.496 0-0.90039-0.38066-0.90039-0.84766 0-0.468 0.40439-0.84766 0.90039-0.84766zm9.2266 0c0.496 0 0.90039 0.38066 0.90039 0.84766s-0.40439 0.84766-0.90039 0.84766-0.89844-0.38066-0.89844-0.84766c0-0.468 0.40244-0.84766 0.89844-0.84766z"
}))), 'DeliveryM', {
  viewBox: '0 0 24 24'
});

exports.default = _default;